export default {
  SET_CONSENT_MODE: 'ui/SET_CONSENT_MANAGER_MODE',
  OPEN_CONSENT_DIALOG: 'ui/OPEN_CONSENT_MANAGER_DIALOG',
  CLOSE_CONSENT_DIALOG: 'ui/CLOSE_CONSENT_MANAGER_DIALOG'
};